var React = require('react');

function Book (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 78V18C16 15.3478 17.0536 12.8043 18.9289 10.9289C20.8043 9.05357 23.3478 8 26 8H80V88H26C23.3478 88 20.8043 86.9464 18.9289 85.0711C17.0536 83.1957 16 80.6522 16 78ZM16 78C16 75.3478 17.0536 72.8043 18.9289 70.9289C20.8043 69.0536 23.3478 68 26 68H80","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Book.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Book;

Book.default = Book;
